import axios from "axios";

// Configuration des clés API
export const API_KEYS = {
  BSC: process.env.REACT_APP_ETHERSCAN_API_KEY,
  ETH: process.env.REACT_APP_ETHERSCAN_API_KEY,
  FTM: process.env.REACT_APP_ETHERSCAN_API_KEY,
  MATIC: process.env.REACT_APP_ETHERSCAN_API_KEY,
  AVAX: process.env.REACT_APP_ETHERSCAN_API_KEY,
  ARB: process.env.REACT_APP_ETHERSCAN_API_KEY,
  BASE: process.env.REACT_APP_ETHERSCAN_API_KEY,
  ZK: process.env.REACT_APP_ZK_API_KEY,
  HYPEREVM: process.env.REACT_APP_ETHERSCAN_API_KEY,
};

// Configuration des URLs d'API - Tout passe par Etherscan V2
export const API_URLS = {
  BSC: "https://api.etherscan.io/v2/api",
  ETH: "https://api.etherscan.io/v2/api",
  FTM: "https://api.etherscan.io/v2/api",
  MATIC: "https://api.etherscan.io/v2/api",
  AVAX: "https://api.etherscan.io/v2/api",
  ARB: "https://api.etherscan.io/v2/api",
  BASE: "https://api.etherscan.io/v2/api",
  ZK: "https://block-explorer-api.mainnet.zksync.io/address",
  HYPEREVM: "https://api.etherscan.io/v2/api",
};

// Chain IDs pour la V2 API
export const CHAIN_IDS = {
  BSC: 56,
  ETH: 1,
  FTM: 250,
  MATIC: 137,
  AVAX: 43114,
  ARB: 42161,
  BASE: 8453,
  HYPEREVM: 999,
};

// Fonction pour construire l'URL complète
export const buildApiUrl = (network, tokenContract, address) => {
  const baseUrl = API_URLS[network];
  const apiKey = API_KEYS[network];

  if (network === "ZK") {
    return `${baseUrl}/${address}/transfers?pageSize=100&page=1`;
  }

  const chainId = CHAIN_IDS[network];
  return `${baseUrl}?chainid=${chainId}&module=account&action=tokentx&contractaddress=${tokenContract}&address=${address}&page=1&offset=100&startblock=0&endblock=2297025780&sort=asc&apikey=${apiKey}`;
};

// // Configuration des URLs d'API
// export const API_URLS = {
//   BSC: "https://api.bscscan.com/api",
//   ETH: "https://api.etherscan.io/api",
//   FTM: "https://api.ftmscan.com/api",
//   MATIC: "https://api.polygonscan.com/api",
//   AVAX: "https://api.snowtrace.io/api",
//   ARB: "https://api.arbiscan.io/api",
//   BASE: "https://api.basescan.org/api",
//   ZK: "https://block-explorer-api.mainnet.zksync.io/address",
//   HYPEREVM: "https://api.etherscan.io/v2/api",
// };

// // Fonction pour construire l'URL complète
// export const buildApiUrl = (network, tokenContract, address) => {
//   const baseUrl = API_URLS[network];
//   const apiKey = API_KEYS[network];

//   if (network === "ZK") {
//     let url = `${baseUrl}/${address}/transfers?pageSize=100&page=1`;
//     return url;
//   }
//   return `${baseUrl}?module=account&action=tokentx&contractaddress=${tokenContract}&address=${address}&page=1&offset=100&startblock=0&endblock=2297025780&sort=asc&apikey=${apiKey}`;
// };

// Fonction pour récupérer et filtrer les transactions
export const fetchZkTransfers = async (address, tokenContract) => {
  console.log("fetchZkTransfers params:", { address, tokenContract });
  const url = buildApiUrl("ZK", tokenContract, address);
  console.log("ZK URL:", url);

  try {
    const response = await axios.get(url);
    console.log("ZK Response:", response.data);

    if (!response.data || !response.data.items) {
      console.error("Réponse invalide de l'API zkSync");
      return {
        receivedAmount: 0,
        lastUpdate: new Date(),
      };
    }

    let receivedAmount = 0;
    response.data.items.forEach((tx) => {
      if (tx && tx.to && tx.tokenAddress && tx.amount && tx.token) {
        if (
          tx.to.toLowerCase() === address.toLowerCase() &&
          tx.tokenAddress.toLowerCase() === tokenContract.toLowerCase()
        ) {
          receivedAmount +=
            parseFloat(tx.amount) / Math.pow(10, tx.token.decimals);
        }
      }
    });

    return {
      receivedAmount,
      lastUpdate: new Date(),
    };
  } catch (error) {
    console.error(
      "Erreur lors de la récupération des transferts zkSync:",
      error
    );
    return {
      receivedAmount: 0,
      lastUpdate: new Date(),
    };
  }
};

// Fonction pour obtenir toutes les URLs et les montants reçus
export const getAllApiUrls = (tokenContract, address) => ({
  BSC: buildApiUrl("BSC", tokenContract, address),
  ETH: buildApiUrl("ETH", tokenContract, address),
  FTM: buildApiUrl("FTM", tokenContract, address),
  MATIC: buildApiUrl("MATIC", tokenContract, address),
  AVAX: buildApiUrl("AVAX", tokenContract, address),
  ARB: buildApiUrl("ARB", tokenContract, address),
  BASE: buildApiUrl("BASE", tokenContract, address),
  ZK: fetchZkTransfers(address, tokenContract),
});

// =====================================================
// VERSION FINALE - Utilise RPC pour le timestamp (plus fiable)
// Copie ces fonctions dans ton api.js
// =====================================================

/**
 * Récupère les détails d'une transaction
 */
export const getTransactionDetails = async (network, txHash) => {
  const baseUrl = API_URLS[network];
  const apiKey = API_KEYS[network];
  
  let url;
  if (network === "HYPEREVM") {
    url = `${baseUrl}?chainid=999&module=proxy&action=eth_getTransactionByHash&txhash=${txHash}&apikey=${apiKey}`;
  } else {
    url = `${baseUrl}?module=proxy&action=eth_getTransactionByHash&txhash=${txHash}&apikey=${apiKey}`;
  }
  
  const response = await axios.get(url);
  return response.data;
};

/**
 * Récupère le timestamp d'un bloc via RPC
 */
export const getBlockTimestamp = async (blockNumber, provider) => {
  try {
    console.log('📦 Récupération du bloc:', blockNumber);
    
    // Convertir en nombre si c'est en hex
    let blockNum = blockNumber;
    if (typeof blockNumber === 'string' && blockNumber.startsWith('0x')) {
      blockNum = parseInt(blockNumber, 16);
    }
    
    // Récupérer le bloc via le provider
    const block = await provider.getBlock(blockNum);
    
    if (!block) {
      throw new Error(`Bloc ${blockNum} introuvable`);
    }
    
    console.log('⏰ Timestamp:', new Date(block.timestamp * 1000).toISOString());
    return block.timestamp;
  } catch (error) {
    console.error('❌ Erreur récupération timestamp:', error);
    throw error;
  }
};

/**
 * Récupère les token transfers d'une transaction via le receipt
 */
export const getTokenTransfers = async (network, txHash) => {
  const baseUrl = API_URLS[network];
  const apiKey = API_KEYS[network];
  
  let url;
  if (network === "HYPEREVM") {
    url = `${baseUrl}?chainid=999&module=proxy&action=eth_getTransactionReceipt&txhash=${txHash}&apikey=${apiKey}`;
  } else {
    url = `${baseUrl}?module=proxy&action=eth_getTransactionReceipt&txhash=${txHash}&apikey=${apiKey}`;
  }
  
  const response = await axios.get(url);
  
  if (!response.data.result || !response.data.result.logs) {
    throw new Error("Impossible de récupérer les logs de la transaction");
  }
  
  // Transfer event signature
  const TRANSFER_TOPIC = "0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef";
  
  const transfers = response.data.result.logs
    .filter(log => log.topics[0] === TRANSFER_TOPIC)
    .map(log => ({
      contractAddress: log.address,
      from: '0x' + log.topics[1].slice(26),
      to: '0x' + log.topics[2].slice(26),
      value: parseInt(log.data, 16).toString(),
      tokenDecimal: 18,
    }));
  
  return {
    status: "1",
    result: transfers
  };
};

/**
 * Récupère les décimales d'un token
 */
export const getTokenDecimals = async (tokenAddress, provider) => {
  try {
    const { ethers } = await import('ethers');
    const ERC20_ABI = ['function decimals() view returns (uint8)'];
    const tokenContract = new ethers.Contract(tokenAddress, ERC20_ABI, provider);
    return await tokenContract.decimals();
  } catch (error) {
    console.warn(`Decimals par défaut pour ${tokenAddress}`);
    return 18;
  }
};

/**
 * Récupère le prix d'un token via CoinGecko
 */
export const getTokenPrice = async (network, tokenAddress, timestamp = null) => {
  try {
    const platformMapping = {
      ETH: "ethereum",
      BSC: "binance-smart-chain",
      MATIC: "polygon-pos",
      ARB: "arbitrum-one",
      BASE: "base",
      AVAX: "avalanche",
      FTM: "fantom",
      HYPEREVM: "hyperevm",
    };
    
    const platform = platformMapping[network];
    if (!platform) return 0;
    
    // Prix actuel
    if (!timestamp) {
      const url = `https://api.coingecko.com/api/v3/simple/token_price/${platform}?contract_addresses=${tokenAddress}&vs_currencies=usd`;
      const response = await axios.get(url);
      return response.data[tokenAddress.toLowerCase()]?.usd || 0;
    }
    
    // Prix historique
    const url = `https://api.coingecko.com/api/v3/coins/${platform}/contract/${tokenAddress}/market_chart/range?vs_currency=usd&from=${timestamp}&to=${timestamp + 86400}`;
    const response = await axios.get(url);
    return response.data.prices?.[0]?.[1] || 0;
  } catch (error) {
    console.error('Erreur prix:', error);
    return 0;
  }
};
// =====================================================
// VERSION SIMPLIFIÉE V3 - Plus facile à maintenir
// =====================================================

/**
 * Détecte si c'est V2 ou V3 et route vers la bonne fonction
 */
export const calculateImpermanentLoss = async (network, txHash, provider) => {
  try {
    const { ethers } = await import('ethers');
    
    console.log('🔍 Analyse de la transaction:', txHash);
    
    // Récupérer transaction
    const txData = await getTransactionDetails(network, txHash);
    if (!txData.result) throw new Error("Transaction introuvable");
    
    const transaction = txData.result;
    
    // Détecter V2 vs V3
    const V3_POSITION_MANAGERS = [
      '0xead19ae861c29bbb2101e834922b2feee69b9091', // Uniswap V3 HyperEVM
      '0xc36442b4a4522e871399cd717abdd847ab11fe88', // Uniswap V3 Ethereum
    ];
    
    const isV3 = V3_POSITION_MANAGERS.some(
      addr => transaction.to.toLowerCase() === addr.toLowerCase()
    );
    
    if (isV3) {
      console.log('📍 Position Uniswap V3 détectée');
      return await calculateV3ImpermanentLoss(network, txHash, provider, transaction);
    } else {
      console.log('📍 Pool V2 détectée');
      return await calculateV2ImpermanentLoss(network, txHash, provider, transaction);
    }
    
  } catch (error) {
    console.error('❌ Erreur:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Calcul IL pour V2 (ton code existant)
 */
export const calculateV2ImpermanentLoss = async (network, txHash, provider, transaction) => {
  try {
    const { ethers } = await import('ethers');
    
    const timestamp = await getBlockTimestamp(transaction.blockNumber, provider);
    
    const transfersData = await getTokenTransfers(network, txHash);
    if (transfersData.status !== "1" || !transfersData.result || transfersData.result.length < 2) {
      throw new Error("Moins de 2 tokens trouvés");
    }
    
    const transfers = transfersData.result;
    const userAddress = transaction.from.toLowerCase();
    const depositTransfers = transfers.filter(t => t.from.toLowerCase() === userAddress);
    
    if (depositTransfers.length < 2) {
      throw new Error(`Seulement ${depositTransfers.length} dépôt(s) détecté(s)`);
    }
    
    const token0Transfer = depositTransfers[0];
    const token1Transfer = depositTransfers[1];
    const poolAddress = transaction.to;
    
    console.log('✅ Pool V2:', poolAddress);
    
    // ... Tout ton code V2 existant ici
    // (Je ne réécris pas tout, tu gardes ce que tu as déjà)
    
  } catch (error) {
    console.error('❌ Erreur V2:', error);
    throw error;
  }
};


// =====================================================
// VERSION V3 - Avec validation decimals et debug
// Remplace calculateV3ImpermanentLoss
// =====================================================

/**
 * Calcul IL pour V3 - Avec validation
 */
export const calculateV3ImpermanentLoss = async (network, txHash, provider, transaction) => {
  try {
    const { ethers } = await import('ethers');
    
    console.log('🎫 Analyse position V3...');
    
    const timestamp = await getBlockTimestamp(transaction.blockNumber, provider);
    const positionManagerAddress = transaction.to;
    
    // 1. Récupérer le receipt complet
    const receiptUrl = API_URLS[network];
    const apiKey = API_KEYS[network];
    
    let url;
    if (network === "HYPEREVM") {
      url = `${receiptUrl}?chainid=999&module=proxy&action=eth_getTransactionReceipt&txhash=${txHash}&apikey=${apiKey}`;
    } else {
      url = `${receiptUrl}?module=proxy&action=eth_getTransactionReceipt&txhash=${txHash}&apikey=${apiKey}`;
    }
    
    const response = await axios.get(url);
    const logs = response.data.result.logs;
    
    console.log(`📋 ${logs.length} logs trouvés`);
    
    // 2. Trouver le TokenId du NFT
    const TRANSFER_TOPIC = "0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef";
    const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";
    
    const nftMintLog = logs.find(log => 
      log.topics[0] === TRANSFER_TOPIC &&
      log.topics[1] === '0x' + ZERO_ADDRESS.slice(2).padStart(64, '0') &&
      log.address.toLowerCase() === positionManagerAddress.toLowerCase()
    );
    
    if (!nftMintLog) throw new Error("TokenId introuvable");
    
    const tokenId = parseInt(nftMintLog.topics[3], 16);
    console.log('🎫 TokenId:', tokenId);
    
    // 3. Trouver l'adresse du pool depuis les logs
    const tokenTransfers = logs.filter(log => 
      log.topics[0] === TRANSFER_TOPIC &&
      log.address.toLowerCase() !== positionManagerAddress.toLowerCase()
    );
    
    console.log(`🔍 ${tokenTransfers.length} transfers de tokens trouvés`);
    
    if (tokenTransfers.length < 2) {
      throw new Error("Impossible de trouver les transfers de tokens");
    }
    
    const poolAddress = '0x' + tokenTransfers[0].topics[2].slice(26);
    console.log('🏊 Pool trouvé:', poolAddress);
    
    // 4. Lire la position depuis le Position Manager
  const POSITION_MANAGER_ABI = [
      'function positions(uint256 tokenId) view returns (uint96, address, address, address, uint24, int24, int24, uint128, uint256, uint256, uint128, uint128)',
  ];
  
  const positionManager = new ethers.Contract(
    positionManagerAddress,
    POSITION_MANAGER_ABI,
    provider
  );
  
    const positionData = await positionManager.positions(tokenId);
    
    const position = {
      token0: positionData[2],
      token1: positionData[3],
      fee: Number(positionData[4]),
      tickLower: Number(positionData[5]),
      tickUpper: Number(positionData[6]),
      liquidity: positionData[7],
    };
    
    console.log('📊 Position:', {
      token0: position.token0,
      token1: position.token1,
      tickLower: position.tickLower,
      tickUpper: position.tickUpper,
      liquidity: position.liquidity.toString(),
    });
    
    // 5. Symboles et décimales (AVEC VALIDATION)
    const ERC20_ABI = [
      'function symbol() view returns (string)',
      'function decimals() view returns (uint8)',
    ];
    
    const token0Contract = new ethers.Contract(position.token0, ERC20_ABI, provider);
    const token1Contract = new ethers.Contract(position.token1, ERC20_ABI, provider);
    
    const [symbol0, symbol1, decimals0Raw, decimals1Raw] = await Promise.all([
      token0Contract.symbol(),
      token1Contract.symbol(),
      token0Contract.decimals(),
      token1Contract.decimals(),
    ]);
    
    // ✅ Validation et conversion des decimals
    const decimals0 = Number(decimals0Raw);
    const decimals1 = Number(decimals1Raw);
    
    console.log('🔢 Decimals:', { decimals0, decimals1 });
    
    // Vérifier que les decimals sont valides
    if (isNaN(decimals0) || decimals0 < 0 || decimals0 > 255) {
      throw new Error(`Decimals invalides pour token0: ${decimals0}`);
    }
    if (isNaN(decimals1) || decimals1 < 0 || decimals1 > 255) {
      throw new Error(`Decimals invalides pour token1: ${decimals1}`);
    }
    
    console.log('🪙 Tokens:', symbol0, '/', symbol1);
    
    // 6. Montants initiaux depuis les logs
    const INCREASE_LIQUIDITY_TOPIC = "0x3067048beee31b25b2f1681f88dac838c8bba36af25bfb2b7cf7473a5847e35f";
    const increaseLiqLog = logs.find(log => log.topics[0] === INCREASE_LIQUIDITY_TOPIC);
    
    if (!increaseLiqLog) throw new Error("IncreaseLiquidity introuvable");
    
    const dataHex = increaseLiqLog.data.startsWith('0x')
      ? increaseLiqLog.data.slice(2)
      : increaseLiqLog.data;
    
    const liquidityProvided = ethers.toBigInt('0x' + dataHex.slice(0, 64));
    const amount0Initial = ethers.toBigInt('0x' + dataHex.slice(64, 128));
    const amount1Initial = ethers.toBigInt('0x' + dataHex.slice(128, 192));
    
    const initialAmount0Decimal = parseFloat(ethers.formatUnits(amount0Initial, decimals0));
    const initialAmount1Decimal = parseFloat(ethers.formatUnits(amount1Initial, decimals1));
    
    console.log('💰 Dépôts initiaux:', {
      liquidity: ethers.formatUnits(liquidityProvided, 18),
      amount0: initialAmount0Decimal,
      amount1: initialAmount1Decimal,
      symbol0: symbol0,
      symbol1: symbol1,
    });
    
    // 7. Lire le slot0 du pool
    const POOL_ABI = [
      'function slot0() view returns (uint160, int24, uint16, uint16, uint16, uint8, bool)',
      'function liquidity() view returns (uint128)',
    ];
    
    const poolContract = new ethers.Contract(poolAddress, POOL_ABI, provider);
    
    const [slot0, poolLiquidity] = await Promise.all([
      poolContract.slot0(),
      poolContract.liquidity(),
    ]);
    
    const sqrtPriceX96 = slot0[0];
    const currentTick = Number(slot0[1]);
    
    console.log('💹 Prix actuel:', {
      tick: currentTick,
      sqrtPriceX96: sqrtPriceX96.toString(),
    });
    
    // 8. ✅ UTILISER UNISWAP SDK avec decimals validés
    const { Pool, Position } = await import('@uniswap/v3-sdk');
    const { Token } = await import('@uniswap/sdk-core');
    
    const chainId = network === 'HYPEREVM' ? 999 : network === 'ETH' ? 1 : 137;
    
    console.log('🔨 Création Token avec:', {
      chainId,
      token0: position.token0,
      decimals0,
      symbol0,
    });
    
    const token0 = new Token(
      chainId,
      position.token0,
      decimals0, // Validé
      symbol0,
      symbol0
    );
    
    const token1 = new Token(
      chainId,
      position.token1,
      decimals1, // Validé
      symbol1,
      symbol1
    );
    
    console.log('✅ Tokens SDK créés');
    
    const pool = new Pool(
      token0,
      token1,
      position.fee,
      sqrtPriceX96.toString(),
      poolLiquidity.toString(),
      currentTick
    );
    
    console.log('✅ Pool SDK créé');
    
    const v3Position = new Position({
      pool: pool,
      liquidity: position.liquidity.toString(),
      tickLower: position.tickLower,
      tickUpper: position.tickUpper,
    });
    
    console.log('✅ Position SDK créée');
    
    // Montants exacts depuis le SDK
    const currentAmount0 = parseFloat(v3Position.amount0.toSignificant(Math.min(decimals0, 18)));
    const currentAmount1 = parseFloat(v3Position.amount1.toSignificant(Math.min(decimals1, 18)));
    
    console.log('💼 Montants actuels exacts:', {
      amount0: currentAmount0,
      amount1: currentAmount1,
      symbol0: symbol0,
      symbol1: symbol1,
    });
    
    // 9. Prix
    const [price0AtDeposit, price1AtDeposit, currentPrice0, currentPrice1] = await Promise.all([
      getTokenPrice(network, position.token0, timestamp),
      getTokenPrice(network, position.token1, timestamp),
      getTokenPrice(network, position.token0),
      getTokenPrice(network, position.token1),
    ]);
    
    console.log('💵 Prix:', {
      [symbol0]: { initial: price0AtDeposit, current: currentPrice0 },
      [symbol1]: { initial: price1AtDeposit, current: currentPrice1 },
    });
    
    // 10. Calculs IL
    const initialValue0 = initialAmount0Decimal * price0AtDeposit;
    const initialValue1 = initialAmount1Decimal * price1AtDeposit;
    const totalInitialValue = initialValue0 + initialValue1;
    
    const ifHoldOnly0 = totalInitialValue / price0AtDeposit;
    const ifHoldOnly1 = totalInitialValue / price1AtDeposit;
    
    const currentLPValue = currentAmount0 * currentPrice0 + currentAmount1 * currentPrice1;
    const hold0Value = ifHoldOnly0 * currentPrice0;
    const hold1Value = ifHoldOnly1 * currentPrice1;
    
    const ilVs0 = ((currentLPValue - hold0Value) / hold0Value) * 100;
    const ilVs1 = ((currentLPValue - hold1Value) / hold1Value) * 100;
    
    const values = { LP: currentLPValue, Hold0: hold0Value, Hold1: hold1Value };
    const bestStrategyKey = Object.keys(values).reduce((a, b) => values[a] > values[b] ? a : b);
    const bestStrategy = bestStrategyKey === 'Hold0' ? `Hold ${symbol0}` : bestStrategyKey === 'Hold1' ? `Hold ${symbol1}` : 'LP';
    
    const inRange = currentTick >= position.tickLower && currentTick < position.tickUpper;
    
    console.log('🎯 Résultats V3:', {
      LP: `$${currentLPValue.toFixed(2)}`,
      Hold0: `$${hold0Value.toFixed(2)}`,
      Hold1: `$${hold1Value.toFixed(2)}`,
      Best: bestStrategy,
      InRange: inRange,
    });
    
    return {
      success: true,
      data: {
        version: 'V3',
        inRange: inRange,
        tokens: { token0: symbol0, token1: symbol1 },
        initial: {
          value: totalInitialValue,
          amount0: initialAmount0Decimal,
          amount1: initialAmount1Decimal,
          price0: price0AtDeposit,
          price1: price1AtDeposit,
          timestamp: timestamp,
          date: new Date(timestamp * 1000).toISOString(),
        },
        current: {
          lpValue: currentLPValue,
          hold0Value: hold0Value,
          hold1Value: hold1Value,
          amount0: currentAmount0,
          amount1: currentAmount1,
          price0: currentPrice0,
          price1: currentPrice1,
        },
        il: { vs0: ilVs0, vs1: ilVs1 },
        bestStrategy,
      },
    };
    
  } catch (error) {
    console.error('❌ Erreur V3:', error);
    throw error;
  }
};